
export default class VwPickingForDeliveryDetailFilter {
	

	constructor(){

	/*APP_FILTER_DEFINITION*/
			this.pickingForDeliveryId = '';
			this.partPartNumber = '';
			this.deliveryInstructionDetailStatusCode = [];
			this.showIsUncompleteOnly='';
			this.exactType = {
				/*APP_APP_FILTER_CRITERIA*/
				pickingForDeliveryId: '0',
				partPartNumber: '0',
				/*END_APP_FILTER_CRITERIA*/
			};
            
	/*END_APP_FILTER_DEFINITION*/
	}

	

}